import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import UserImg from "../../assets/images/providerProfileImg.png";
import { useNavigate } from "react-router-dom";
import {
  capitalizeFirstLetter,
  convertDateFormat,
  fetchImage,
  getFullName,
  twoDecimalPlaces,
} from "../../utils/common";
import { setJobId } from "../../slice/commonSlice";
import { useDispatch } from "react-redux";

import StarRating from "../../components/rating/StarRating";
import socket from "../../socket/socket";

import MarkJobComplete from "../markJobComplete/MarkJobComplete";
import CancelModal from "../../modals/confirmModal/CancelModal";
import Tooltip from '@mui/material/Tooltip';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
const JobBox = ({
  type,
  job,
  updateJobRequest,
  cancelRequest,
  handleDispute,
  handleTip,
  handlePayment,
  handleInvoice,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [MarkComplete, setMarkComplete] = useState(false);
  const [jobIdDelete, setJobIdDelete] = useState("");
  const [providerIdDelete, setProviderIdDelete] = useState("");
  const [paymentIdDelete, setPaymentIdDelete] = useState("");
  const [profilePicURL, setProfilePicURL] = useState(UserImg); // Default image
  let jobCancelled = false;

  // const getPrice = () => {
  //   if (!job?.durationExpected) {
  //     if (job?.durationUpdated && job?.finalPrice) {
  //       return `$${twoDecimalPlaces(job?.finalPrice)}`;
  //     } else {
  //       return `$${twoDecimalPlaces(job?.unitPrice)}/hour`;
  //     }
  //   } else {
  //     return `$${twoDecimalPlaces(job?.finalPrice)}`;
  //   }
  // };

  const getPrice = () => {
  const price =
    job?.finalPriceAfterDiscount ??
    job?.finalPrice ??
    job?.unitPrice;

  if (!job?.durationExpected) {
    if (job?.durationUpdated && job?.finalPrice) {
      return `$${twoDecimalPlaces(price)}`;
    } else {
      return `$${twoDecimalPlaces(price)}/hour`;
    }
  } else {
    return `$${twoDecimalPlaces(price)}`;
  }
};


  const handleView = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/consumer/job/detail");
    }
  };

  const handleViewProfile = (id) => {
    if (id) {
      navigate("/job/profile", { state: id });
    }
  };

  const handleReshare = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/share-requote");
    }
  };

  const handleViewStatus = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/status");
    }
  };



  useEffect(() => {
    const fetchProfileImage = async () => {
      if (job?.providerId?.profilePic) {
        try {
          const fetchedUrl = await fetchImage(job.providerId.profilePic);
          setProfilePicURL(fetchedUrl); 
        } catch (error) {
          console.error("Error fetching profile image:", error);
          setProfilePicURL(UserImg); 
        }
      }
    };

    fetchProfileImage();
  }, [job?.providerId?.profilePic]); 


  //function to navigate to chat
  const handleChatNow = (job) => {
    const loggedinuserId = job?.userId?._id;
    socket.emit("create-new-chat", [job?.providerId?._id, loggedinuserId]);
    socket.on("new-chat-created", (data) => {
      let chatID = data._id;
      navigate(`/chat`);
    });
  };

  const handleRehire = async (job) => {
    let payload = {
      id: job?.providerId?._id,
      serviceId: job?.serviceId?._id,
      serviceName: job?.serviceId?.name,
      jobType: job?.serviceId?.jobType,
    };
    navigate("/consumer/viewprofile", { state: payload });
  };

  const handleDelete = (jobId, providerID, paymentProfileId) => {
    setConfirmStatus(true);
    setJobIdDelete(jobId);
    setProviderIdDelete(providerID);
    setPaymentIdDelete(paymentProfileId);
  };

  const handleConfirm = (status) => {
    if (status) {
      cancelRequest(jobIdDelete, providerIdDelete, paymentIdDelete);
    }
    setConfirmStatus(false);
  };

  return (
    <div className="job-box">
      <div className="user-info-detail-wrap">
        <div className="user-detail-left">
          <div className="user-pic">
            <img src={profilePicURL} alt="Provider" />
          </div>
          <div className="user-detail">
            <div className="user-name-wrap">
              {getFullName(
                job?.providerId?.firstName,
                job?.providerId?.lastName
              )}
            </div>
            <div className="rating-wrap">
              <div className="rating">
                <StarRating
                  size={18}
                  rating={job?.providerId?.ratingProvider}
                />
                {/* <StarOutline /> <StarOutline /> <StarOutline /><StarOutline /> <StarOutline /> */}
              </div>
              <div className="rating-value">
                {job?.providerId?.ratingProvider ? (
                  <>({job?.providerId?.ratingProvider}) </>
                ) : (
                  `(0)`
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className='user-detail-right otp'>OTP 3564</div> */}
        {/* { (type === 'outgoing') && <div  className='user-detail-right'>Request status : <span className={`${job?.requestStatus}`}>{capitalizeFirstLetter(job?.requestStatus)}</span></div> } */}
        {type === "cancelled" && (
          <div className="user-detail-right">
            {" "}
            {job?.jobStatus == "REJECTED" ? <span className="cancelled">Rejected</span> : <span className="cancelled">Cancelled</span>}

          </div>
        )}
        {/* { type === 'upcoming' && <div className='user-detail-right otp'>OTP {job?.otp}</div> } */}
      </div>
      {/* <div className='job-title-wrap'>
        <div className='job-title'>{job?.serviceId?.name || job?.serviceName}</div>

      </div> */}
      {type === "upcoming" &&
        job?.paymentStatus === "pending" &&
        job?.paymentFailed && (
          <div className="payment-failed">
            Payment Failed, Please pay payment by clicking on Pay Now
          </div>
        )}

      <div className="job-decription">{job?.jobDetail}</div>

      <div className="job-location-detail">
        <tr>
          <Tooltip
            title="If you would like to change the address, please chat with the provider, or cancel this job and book a new one."
            place="top"
          >
            <InfoOutlineIcon style={{ marginLeft: "140px" }} />
          </Tooltip>
        </tr>
        <ul>
          <li>
            {" "}
            <span>Job Type :</span> {capitalizeFirstLetter(job?.jobType)}
          </li>
          <li>
            <span>Date & Time : </span>
            {job?.startTime ? convertDateFormat(job?.startTime) : convertDateFormat(job?.jobStartTime)}
          </li>

          <li>
            <span>Price :</span> {getPrice(job)}
          </li>
          <li>
            <span>Job Rate :</span>
            {(type === "upcoming" ||
              type === "completed" ||
              type === "incoming") &&
              job?.fixedPrice > 0
              ? "Fixed"
              : "Hourly"}
          </li>
        </ul>
      </div>
      <div className="job-btn-wrap">
        {type === "upcoming" && (
          <>
            {job?.jobType === "services" ? (
              <Button
                variant="outline-primary"
                onClick={() => handleView(job?._id)}
              >
                View Details
              </Button>
            ) : (
              <Button
                variant="outline-primary"
                onClick={() => handleViewStatus(job?._id)}
              >
                View Status
              </Button>
            )}

            <Button
              variant="outline-primary"
              onClick={() => handleViewProfile(job?.providerId?._id)}
            >
              View Helpr Profile
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => handleChatNow(job)}
            >
              Chat Now
            </Button>
            {job?.paymentStatus === "pending" && job?.paymentFailed ? (
              <Button
                variant="outline-primary"
                onClick={() => handlePayment(job)}
              >
                Pay Now
              </Button>
            ) : null}
            <Button
              variant="outline-primary"
              onClick={() =>
                handleDelete(
                  job?._id,
                  job?.providerId?._id,
                  job?.paymentProfileId
                )
              }
            >
              Cancel
            </Button>
           
          </>
        )}
        {type === "completed" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
            {!job?.isDisputed ? (
              <Button
                variant="outline-primary"
                onClick={() => handleDispute(true, job)}
              >
                Raise Dispute
              </Button>
            ) : null}
            {/* <Button variant="outline-primary" onClick={()=>handleChatNow(job)}>Chat Now</Button> */}
            <Button variant="outline-primary" onClick={() => handleRehire(job)}>
              Re-Hire
            </Button>
            {job?.tip == 0 || !job?.tip ? (
              <Button variant="outline-primary" onClick={() => handleTip(job)}>
                Give Tip
              </Button>
            ) : null}
            {job?.paymentStatus === "completed" ? (
              <Button
                variant="outline-primary"
                onClick={() => handleInvoice(job)}
              >
                Download Invoice
              </Button>
            ) : null}
          </>
        )}
        {type === "cancelled" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
          </>
        )}
        {type === "past" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
          </>
        )}
        {type === "incoming" && (
          <>
            <Button
              variant="success"
              onClick={() =>
                updateJobRequest(job?._id, "accepted", job?.providerId?._id)
              }
            >
              Accept
            </Button>
            <Button
              variant="danger"
              onClick={() =>
                updateJobRequest(job?._id, "rejected", job?.providerId?._id)
              }
            >
              Reject
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => handleViewProfile(job?.providerId?._id)}
            >
              View Helpr Profile
            </Button>
          </>
        )}
        {type === "outgoing" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() =>
                handleDelete(
                  job?._id,
                  job?.providerId?._id,
                  job?.paymentProfileId
                )
              }
            >
              Cancel Request
            </Button>
          </>
        )}
        {confirmStatus ? (
          <CancelModal
            isConfirm={confirmStatus}
            text={
              type === "upcoming"
                ? `Are you sure you would like to cancel this job ? A cancellation charge will be applicable as you have passed ${job.providerId.cancellationPolicy} Hr the cancellation notice period.`
                : `You want to cancel this job`
            }
            handleClose={handleConfirm}
            jobCancelled={jobCancelled}
          />
        ) : null}
        -
        {MarkComplete ? (
          <MarkJobComplete
            MarkComplete={MarkComplete}
            setMarkComplete={setMarkComplete}
            jobId={job}
          />
        ) : null}
      </div>
    </div>
  );
};

export default JobBox;
